﻿window.paceOptions = {
  ajax: {
    trackMethods: new Array("GET", "POST"),
    ignoreURLs: [/.*notifications\/popups.*/i, 'arterySignalR', 'browserLink'],
    trackWebSockets: false
  },
  startOnPageLoad: false,
  restartOnRequestAfter: 250,
  target: 'body'
};